import BaseCrudService from "./baseCrud.service";

export default class CheckoutSimplifiedQuestionService extends BaseCrudService {

	constructor() {
		super('CheckoutSimplifiedQuestion');
	}

	getQuestionsWithOptionsByCampaignId(campaignId) {
		return this.getRequest("GetQuestionsWithOptionsByCampaignId", { campaignId });
	}

	// Perguntas customizadas da modal de confirmacao de dados (ShowOnPersonInfoModal).
	getPersonInfoQuestionsByCampaignId(campaignId) {
		return this.getRequest("GetPersonInfoQuestionsByCampaignId", { campaignId });
	}

	listMyPersonInfoAnswers(campaignId) {
		return this.getRequest("ListMyPersonInfoAnswers", { campaignId });
	}

	// true quando o usuario logado tem pergunta obrigatoria da modal sem resposta (campaignId 0 = subdominio).
	hasMyPendingPersonInfoQuestions(campaignId = 0) {
		return this.getRequest("HasMyPendingPersonInfoQuestions", { campaignId }, false, false);
	}

	saveMyPersonInfoAnswers(campaignId, answers) {
		return this.postRequest("SaveMyPersonInfoAnswers", { campaignId, answers });
	}

}